const reports = {
  exportPdf: 'Export PDF',
  generatedBy: 'Generated by SpeedGauge Coach AI',
  exportDescription: 'Export Coach AI answer as PDF',
  exportingPdf: 'Exporting PDF',
  exportFailed: 'PDF export failed',
  loadingMap: 'Loading map...',
  generatedAt: 'PDF {{timestamp}}',
  dataSources: 'Data sources',
  staticMapCaption: 'Static map snapshot captured from the chat map display.',
  audit: {
    customer: 'Customer',
    customerId: 'Customer ID',
    vehicleGroup: 'Vehicle group',
    vehicleGroupId: 'Vehicle group ID',
    user: 'User',
    sessionId: 'Session ID',
    messageId: 'Message ID',
    messageTimestamp: 'Message timestamp',
  },
  pdf: {
    confidential: '- CONFIDENTIAL -',
    verificationDisclaimer: 'Results may require review and verification',
    page: 'Page {{page}} of {{total}}',
  },
  map: {
    location: 'Location',
    title: 'Map',
    snapshot: 'Map snapshot',
    speedLimitLookup: 'Speed limit lookup ({{coordinates}})',
    speedZone: '{{speed}} {{unit}} in {{limit}} {{unit}} zone (+{{difference}})',
    speedLimit: '{{speed}} {{unit}} (limit {{limit}}, +{{difference}})',
    incident: 'Incident',
  },
} as const;

export default reports;